import SlideManager from "../utils/slide-manager";
import QuizManager from "../quizes/quiz-manager";
import { goToSlide } from "../slides/add-slide-controls";
import RenderManager from "../rendering/render-manager";
import { convertSlideUUIDToIndex } from "../utils/convert-slide-data";

async function setSlide(targetSlide, opts) {
    if (typeof targetSlide !== 'number') { targetSlide = convertSlideUUIDToIndex(targetSlide, Q3.data.slides); }

    await SlideManager.waitForSlide(targetSlide);
    goToSlide(targetSlide, opts);
}

const LoopModes = {
    'loop': THREE.LoopRepeat,
    'ping-pong': THREE.LoopPingPong,
};

function getActionLoopMode(actionValue) {
    if (!actionValue.loop) return THREE.LoopOnce;

    return LoopModes[actionValue.loopType] || THREE.LoopRepeat;
}

class Transition {

    constructor(systemAction, options, object) {
        // based on options we populate
        this.systemAction = systemAction;
        this.options = options;
        this.object = object;
        this.prevScrollPos = 0;
        this.audio = null;
        this.isListening = false;
        this.graph = null;
    }

    findGraph() {
        let graph = null;
        if (this.options.objectUuid && this.options.chartUuid && this.options.targetParameter) {
            graph = Q3.layers.list[this.options.objectUuid].objects[0].charts.data().find(c => c._uuid === this.options.chartUuid);
        }
        return graph;
    }

    scroll(el) {

        //if animation
        this.options.animationUuid ? this.handleAnimationOnScroll(el) : null;

        //if quizToLaunch
        this.options.quizToLaunch ? this.launchQuizOnScroll(el) : null;

        //if slideToGo
        this.options.slideToGo ? this.navigateToSlideOnScroll(el) : null;

        this.options.scrollPositions ? this.navigateToSlideOnScroll(el) : null;
    }

    playPauseAnimation() {
        const isPlaying = Q3.mixer.getObjectAnimationStatus(this.options.objectUuid) === Q3.mixer.Status.PLAYING;
        if (isPlaying) {
            Q3.mixer.pauseObjectCurrentAnimation(this.options.objectUuid);
        } else {
            let loopType = getActionLoopMode(this.options);
            Q3.mixer.playObjectAnimation({
                objectUuid: this.options.objectUuid,
                animationUuid: this.options.animationUuid,
                loopType,
                timescale: this.options.animationSpeed,
                repetitions: this.options.repeat,
                timeRange: this.options.animationTimeline,
                resume: true,
            });
        }
    }

    addTimePlayedAction(object, time) {
        const handler = () => {
            if (object.currentTime >= time) {
                this.click();
                object.removeEventListener("timeupdate", handler);
            }
        };
        object.addEventListener("timeupdate", handler)
    }

    click() {
        switch (this.systemAction) {
            case 'navigate':
                setSlide(this.options.slide, { userAction: true, ignore: true });
                break;
            case 'playaudio':
                let asset = Q3.data.assets.audio[this.options.audioUuid];
                if (asset) {
                    this.audio = this.audio || new Audio();
                    this.audio.src = Q3.s3Url + asset.path;
                    this.audio.currentTime = 0;
                    if (asset.volume) {
                        this.audio.volume = asset.volume;
                    }
                    this.audio.play();
                    const onSlideChange = () => {
                        this.audio.pause();
                        this.audio.removeAttribute("src");
                        this.audio = null;
                        setTimeout(() => {
                            Q3.Events.unlisten("leaveslide", onSlideChange)
                        }, 1)
                    };
                    !this.isListening && Q3.Events.listen("leaveslide", onSlideChange);
                    this.isListening = true;
                }
                break;
            case 'animate':
                let loopType = getActionLoopMode(this.options);
                Q3.mixer.playObjectAnimation({
                    objectUuid: this.options.objectUuid,
                    animationUuid: this.options.animationUuid,
                    loopType,
                    timescale: this.options.animationSpeed,
                    repetitions: this.options.repeat,
                    timeRange: this.options.animationTimeline,
                });
                break;
            case 'playpause':
                this.playPauseAnimation();
                break;
            case 'stopanimation':
                Q3.mixer.stopObjectCurrentAnimation(this.options.objectUuid, 0);
                break;
            case 'link':
                this.options.href = this.options.href[0] === "/" ? window.location.origin + this.options.href : (this.options.href.indexOf("http://") === 0 || this.options.href.indexOf("https://") === 0) ? this.options.href : "http://" + this.options.href;
                window.open(this.options.href, this.options.sameWindow ? "_self" : "_blank")
                break;
            case 'hide3d': {
                let obj = Q3.assets.objects[this.options.objectUuid] || Q3.assets.lights[this.options.objectUuid];
                if (obj && obj.visible) {
                    obj.visible = false;
                    Q3.RenderManager.activeCamera.update = true;
                }
                break;
            }
            case 'unhide3d': {
                let obj = Q3.assets.objects[this.options.objectUuid] || Q3.assets.lights[this.options.objectUuid];
                if (obj && !obj.visible) {
                    obj.visible = true;
                    Q3.RenderManager.activeCamera.update = true;
                }
                break;
            }
            case 'unhide2d':
                if (this.options.objectUuid in Q3.SlideManager.currentSlide.layers && Q3.SlideManager.currentSlide.layers[this.options.objectUuid] === false) {
                    let prevstate = Q3.SlideManager.currentSlide.layers[this.options.objectUuid];
                    Q3.SlideManager.currentSlide.layers[this.options.objectUuid] = true;
                    Q3.layers.update();
                    if (Q3.layers.list[this.options.objectUuid].objects[0].enableAutoplay) {
                        Q3.layers.list[this.options.objectUuid].objects[0].enableAutoplay();
                    }
                    let slide = Q3.SlideManager.activeSlide;
                    Q3.SlideManager.callbacks.push(() => {
                        Q3.data.slides[slide].layers[this.options.objectUuid] = prevstate;
                    })
                }
                break;
            case 'hide2d':
                if (this.options.objectUuid in Q3.SlideManager.currentSlide.layers) {
                    let prevstate = Q3.SlideManager.currentSlide.layers[this.options.objectUuid];
                    Q3.SlideManager.currentSlide.layers[this.options.objectUuid] = false;
                    Q3.layers.update();
                    if (Q3.layers.list[this.options.objectUuid].objects[0].stop) {
                        Q3.layers.list[this.options.objectUuid].objects[0].stop();
                    }
                    let slide = Q3.SlideManager.activeSlide;
                    Q3.SlideManager.callbacks.push(() => {
                        Q3.data.slides[slide].layers[this.options.objectUuid] = prevstate;
                    })
                }
                break;
            case 'playvideo':
                if (Q3.layers.list[this.options.objectUuid]) {
                    let currentVideo = Q3.layers.list[this.options.objectUuid].objects[0];
                    currentVideo.play();
                    if (this.object && this.object.type2d === "Button")
                        this.object.setPlayStyle();
                }
                break;
            case 'stopvideo':
                if (Q3.layers.list[this.options.objectUuid]) {
                    let currentVideo = Q3.layers.list[this.options.objectUuid].objects[0];
                    currentVideo.pause();
                    currentVideo.video.currentTime = 0;
                }
                break;
            case 'playpausevideo':
                if (Q3.layers.list[this.options.objectUuid]) {
                    let currentVideo = Q3.layers.list[this.options.objectUuid].objects[0];
                    let isVideoPaused = Q3.layers.list[this.options.objectUuid].objects[0].isPaused;
                    if (isVideoPaused) {
                        currentVideo.play();
                        if (this.object && this.object.type2d === "Button")
                            this.object.setPlayStyle();
                    } else if (!isVideoPaused) {
                        currentVideo.pause();
                        if (this.object && this.object.type2d === "Button")
                            this.object.setStopStyle();
                    }
                }
                break;
        }

        if (this.options.quizToLaunch) QuizManager.initSlideQuiz(this.options.quizToLaunch);
    }

    slide(value) {
        switch (this.systemAction) {
            case 'rewind': {
                let duration = Q3.layers.list[this.options.objectUuid].objects[0].duration;
                Q3.layers.list[this.options.objectUuid].objects[0].setCurrentTime(value * duration);
                break;
            }
            case 'playpause':
            case 'animate': {
                if (this.options.animationUuid && this.options.objectUuid) {
                    Q3.mixer.setObjectAnimationFrame({
                        objectUuid: this.options.objectUuid,
                        animationUuid: this.options.animationUuid,
                        frame: value,
                        timeRange: this.options.animationTimeline,
                    });
                }
                break;
            }
            case 'setgraph': {
                if (!this.graph) {
                    this.graph = this.findGraph();
                }
                if (this.graph) {
                    let min = this.options.min;
                    let max = this.options.max;
                    let totalAmount = max - min;

                    this.graph.params()[this.options.targetParameter] = totalAmount * value + min;
                    Q3.layers.list[this.options.objectUuid].objects[0].needsUpdate = true;
                }
                break;
            }
            case 'navigate': {
                if (this.options.slide !== undefined && value === 1) { setSlide(this.options.slide); }
                break;
            }
            default: break;
        }



    }

    getMixer() {
        return this.mixer;
    }


    handleAnimationOnScroll(el) {

        if (!this.scrollableHeight) this.setScrollableHeight(el);

        //according to scroll top move the animation
        const deltaScroll = el.scrollTop - this.prevScrollPos;
        this.prevScrollPos = el.scrollTop;


        const deltaTime = (deltaScroll / this.scrollableHeight) * this.animationTime * this.timeScale;

        this.mixer.update(deltaTime);
        RenderManager.activeCamera.update = true;

    }

    launchQuizOnScroll(el) {

        if (!this.scrollableHeight) this.setScrollableHeight(el);

        if (el.scrollTop === this.scrollableHeight) {
            QuizManager.initSlideQuiz(this.options.quizToLaunch);
        }
    }

    navigateToSlideOnScroll(el) {

        const that = this;
        if (!this.scrollableHeight) this.setScrollableHeight(el);

        Q3.scrollPositions = Q3.scrollPositions || [];

        if (this.options.scrollPositions && !Q3.scrollPositions[this.options.uuid]) {
            //set the scroll positions
            this.options.scrollPositions[this.options.startSlide] = 0;

            const textElementTop = el.getBoundingClientRect().top;
            el.innerHTML += '<hr class="horizontal-marker viewer"></hr>';
            const markers = $(el).find('.horizontal-marker');
            let slide = this.options.startSlide + 1;

            for (var i = 0; i < markers.length; i++) {
                this.options.scrollPositions[slide++] = Math.round(markers[i].getBoundingClientRect().top - textElementTop);
            }

            Q3.scrollPositions[this.options.uuid] = this.options.scrollPositions;


        }


        if (this.options.scrollPositions && Q3.scrollPositions[this.options.uuid]) {

            Q3.scrollPositions[this.options.uuid].forEach(function (pos, index) {

                if (pos !== -1 && el.scrollTop > pos && el.scrollTop < Q3.scrollPositions[that.options.uuid][index + 1]) {

                    if (SlideManager.activeSlide !== index) {
                        setSlide(index, { byScroll: true });
                    }
                }

            });



        } else {

            if (el.scrollTop === this.scrollableHeight) {
                setSlide(this.options.slideToGo);
            }

        }

    }

    setScrollableHeight(el) {

        this.scrollableHeight = Math.round(el.scrollHeight - el.getBoundingClientRect().height);
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }



}

export default Transition;
export { Transition };
